<template lang="pug">
#auth-layout
  Messages
  .auth-container
    router-view
</template>

<script>
import Messages from '@/components/global/Messages.vue';

export default {
  name: 'AuthLayout',
  components: {
    Messages,
  },
  mounted() {
    // Ocultar elementos del layout principal si existen
    document.body.classList.add('auth-page');
  },
  beforeUnmount() {
    document.body.classList.remove('auth-page');
  },
};
</script>
